import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/** A fresh Idempotency-Key for one user action (keep it across retries of that action). */
export function idempotencyKey(): string {
  return crypto.randomUUID()
}
